<template>
     <!-- v-if="pageId==='1'"  -->
	<div  class="functionlist">
 
        <div  v-for="(item) of tool_1" v-bind:key="item.child_id" class="function_box" :data-type="item.type" :data-detail="item.detail"   >
           <!-- @click="TurnToFunction" -->
          <router-link :to="{name:item.detail}" class="router">  
            <img :src="item.image" :data-type="item.type" :data-detail="item.detail">
            <div class="function_itemname" :data-type="item.type" :data-detail="item.detail">{{item.name}}</div>
          </router-link>

           
        </div> 
        
       <img src="@/assets/images/ads/tools.png" alt="律师云助理"  class="hidden_img"   style="display:none" >

    </div>
    
	
</template> 

<script>



// const routes = [ 
 
//   // { path: '/', redirect:'/tools'},
//   {path:'/tools', component: ()=>import('@/components/toolsbox/cal.vue') ,name:"tools" },
//   // {path:'/tools/sound2txt', component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue'),name:"sound2txt" },  
//   {path:'/tools/legalfee', component: ()=>import('@/components/functions/legalfee.vue') ,name:"legalfee" },
 

 
// ] 

// import VueRouter from 'vue-router' 
// const router = new VueRouter({
//   routes,
//   mode:'history'  
// })
 import consult from '@/components/ads/consult.vue' 

	export default {
    name: 'cal', 
    // props: {
    // pageId: String
    // },
    // router,
    data() {
			return { 
				// fit: 'cover',
            // url: 'http://www.lawtip.cn/images/mini_yzl.jpg',
            // type:'1',
            tool_1:[ {
              child_id: 1,
              name: '诉讼费计算器',
              image: require("../../assets/toolspic/t33.png"),
              detail: "legalfee" , 
              type:"11"
              
            },
            {
              child_id: 2,
              name: '律师费计算器',
              image: require("../../assets/toolspic/1113503.gif"),
              detail:"lawyerfee",
               type:"12"
            },
            {
              child_id: 3,
              name: '基准利息计算器(190820前)',
              image: require("../../assets/toolspic/t22.png"),
              detail:"interest",
               type:"13"
            },
            {
              child_id: 4,
              name: '天数计算器',
              image:   require("../../assets/toolspic/t27.png"), //"../../assets/toolspic/t27.png  ",
              detail:"daycal",
              type:"14"
            },
             {
              child_id: 5,
               name: '诉讼保全险计算器',
               image: require("../../assets/toolspic/t34.png"),
               detail:"subao",
              type:"15"
            },
            {
              child_id: 6,
              name: '交通/人损赔偿计算器',
              image: require("../../assets/toolspic/t35.png"),
              detail:"traffic",
              type:"16"
            },
            {
              child_id: 7,
              name: '工伤赔偿计算器',
              image: require("../../assets/toolspic/t36.png"),
              detail:"workinjury",
              type:"17"
            },
            {
              child_id: 8,
              name: '执行期利息计算器',
              image: require("../../assets/toolspic/zhixingcal.png"),
              detail: "enforce",
              type:"18"
            },
            {
              child_id: 9,
              name: '自定义利息计算器',
              image: require("../../assets/toolspic/t22.png"),
              detail: "interest2",
              type:"19"
            },
            {
              child_id: 10,
              name: 'LPR利息计算器(20年新规)',
              image:  require("../../assets/toolspic/t22.png"),
              detail: "lpr",
              type:"110"
            },
             {
              child_id: 11,
              name: '数字转大写',
              image:  require("../../assets/toolspic/logo_one.png"),
              detail: "numtrans",
              type:"20"
            },

            {
              child_id: 12,
              name: '录音证据转文字',
              image:  require("../../assets/toolspic/sound.png"),
              detail: "sound2txt",
              type:"81"
            },
            {
              child_id: 13,
              name: '高级合同违约金计算器',
              image:  require("../../assets/toolspic/calculate67.png"),
              detail: "int4",
              type:"21"
            },
              {
              child_id: 14,
              name: '民间借贷计算器',
              image:  require("../../assets/toolspic/loan.png"),
              detail: "int5",
              // type:"21"
            }
            
            ] ,
           
			}
    },
    components: { 
      consult
    
    },
    methods:{
      TurnToFunction(e){
        window.console.log('push event')
        window.console.log(e)

        window.console.log(e.srcElement.dataset.type)
        // var type=e.srcElement.dataset.type
        var detail=e.srcElement.dataset.detail
        window.console.log('detail:',detail)

        this.$router.push({name:detail})
       
      //  if (type=='81'){
      //     this.$router.push({path:'/sound2txt'})
      //   }else{
      //     this.$emit('ChangeFunctionBox',e.srcElement.dataset.type); 
      //   }
        




      }
    }
	}
</script>

<style  >
  
  body
{

    background-color: #fff;
  
}   

  .functionlist{
      width:96%;
      height: 100%;
      /* padding: 15px; */
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      /* line-height: 40px; */
      /* border:1px solid #c41cc4; */
      margin-left: auto;
      margin-right: auto;
      /* background-color: #fff; */
      
  }
  .function_box{
      display: flex;
      flex-direction: column;
      align-items:center;
      height: 130px;
      width:90px;
      /* border:1px solid #4fb898; */
      margin-left: 50px;
      margin-top:30px;
      cursor: pointer;
  }
  .function_box img{
      width:60px;
      height: 60px;
  }
  .function_itemname{
      text-align:center;
      margin-top:8px;
  }
	

  .router{
    height: 100%;
    width:100%;
    color:black;
    text-decoration:none;
    /* border:1px solid #4fb898; */
    text-align: center;
  }


  .hidden_img{
    position: fixed;
    top:100px;
    z-index: -1;
    max-width: 950px;
    height: auto;
  }

</style>
